module.exports = __webpack_public_path__ + "static/pinkfairy1-988adf7d3e9ffb00062f2b05e2ca55c9.png";